import React from 'react'
import c from 'classnames'

const SelectableCitationItem = ({ citation, handleClick }) => {
  const { citationId, issuedAt, violation, balanceDue, selected } = citation
  return (
    <div className="flex bg-white rounded-lg p-3.5 mb-3.5" onClick={handleClick}>
      <div
        className={c(
          'w-5 h-5 border-2 rounded-full border-primary-light transition-all mr-3.5 flex-shrink-0',
          selected && 'border-8'
        )}
      />
      <div className="flex flex-col w-full">
        <div className="flex justify-between pb-3">
          <span>{citationId}</span>
          <span>{issuedAt.split('-').join('/')}</span>
        </div>
        <div className="flex justify-between">
          <span>{violation}</span>
          <span className="font-bold">{`$${balanceDue}`}</span>
        </div>
      </div>
    </div>
  )
}

export default SelectableCitationItem
